import { ChainId } from '@donaswap/sdk'

export const supportedChainIdV2 = [
  ChainId.FIRECHAIN,
  ChainId.RINIA,
  ChainId.BSC,
  ChainId.BSC_TESTNET,
  ChainId.ETHEREUM,
  ChainId.GOERLI,
  ChainId.SEPOLIA,
  ChainId.POLYGON,
  ChainId.POLYGON_MUMBAI,
  ChainId.POLYGON_ZKEVM,
  ChainId.POLYGON_ZKEVM_TESTNET,
  ChainId.CRO,
  ChainId.CRO_TESTNET,
  ChainId.AVALANCHE,
  ChainId.AVALANCHE_FUJI,
  ChainId.FANTOM_OPERA,
  ChainId.FANTOM_TESTNET,
  ChainId.CELO,
  ChainId.CELO_ALFAJORES,
  ChainId.OPTIMISM,
  ChainId.OPTIMISM_GOERLI,
  ChainId.ARBITRUM_ONE,
  ChainId.ARBITRUM_GOERLI,
  ChainId.SHIBARIUM,
  ChainId.SHIBARIUM_TESTNET,
  ChainId.PULSECHAIN,
  ChainId.PULSECHAIN_TESTNET,
  ChainId.XEN,
  ChainId.XEN_DEVNET,
  ChainId.HARMONY,
  ChainId.HARMONY_TESTNET,
  ChainId.COINEX,
  ChainId.COINEX_TESTNET,
  ChainId.DOGECHAIN,
  ChainId.DOGECHAIN_TESTNET,
  ChainId.ETHEREUM_CLASSIC,
  ChainId.ETHEREUM_CLASSIC_TESTNET,
  ChainId.FUSION,
  ChainId.FUSION_TESTNET,
  ChainId.HECO,
  ChainId.HECO_TESTNET,
  ChainId.KCC,
  ChainId.KCC_TESTNET,
  ChainId.KLAYTN,
  ChainId.KLAYTN_BAOBAB,
  ChainId.OKXCHAIN,
  ChainId.OKXCHAIN_TESTNET,
  ChainId.THETHA,
  ChainId.THETHA_TESTNET,
  ChainId.ULTRON,
  ChainId.ULTRON_TESTNET,
  ChainId.MOONBEAM,
  ChainId.MOONRIVER,
  ChainId.MOONBASE_ALPHA,
  ChainId.AURORA,
  ChainId.AURORA_TESTNET,
  ChainId.BOBA,
  ChainId.BOBA_GOERLI,
  ChainId.GNOSIS,
  ChainId.GNOSIS_CHIADO,
  ChainId.METIS,
  ChainId.METIS_GOERLI,
  ChainId.TELOS,
  ChainId.TELOS_TESTNET,
  ChainId.SYSCOIN,
  ChainId.SYSCOIN_TANENBAUM,
  ChainId.IOTEX,
  ChainId.IOTEX_TESTNET,
  ChainId.SHIDEN,
  ChainId.ASTAR,
  ChainId.SHIBUNYA,
  ChainId.FUSE,
  ChainId.FUSE_SPARKNET,
  ChainId.VELAS,
  ChainId.VELAS_TESTNET,
  ChainId.REI,
  ChainId.REI_TESTNET,
  ChainId.KEKCHAIN,
  ChainId.KEKCHAIN_TESTNET,
  ChainId.TOMOCHAIN,
  ChainId.TOMOCHAIN_TESTNET,
  ChainId.THUNDERCORE,
  ChainId.THUNDERCORE_TESTNET,
  ChainId.WANCHAIN,
  ChainId.WANCHAIN_TESTNET,
  ChainId.RSK,
  ChainId.RSK_TESTNET,
  ChainId.ELASTOS,
  ChainId.ELASTOS_TESTNET,
  ChainId.CONFLUX,
  ChainId.CONFLUX_TESTNET,
  ChainId.BRISECHAIN,
  ChainId.BRISECHAIN_TESTNET,
  ChainId.MUUCHAIN,
  ChainId.MUUCHAIN_TESTNET,
  ChainId.CANTO,
  ChainId.CANTO_TESTNET,
  ChainId.OASIS_EMERALD,
  ChainId.OASIS_TESTNET,
  ChainId.VISION,
  ChainId.VISION_TESTNET,
  ChainId.STEP,
  ChainId.STEP_TESTNET,
  ChainId.METER,
  ChainId.METER_TESTNET,
  ChainId.GODWOKEN,
  ChainId.GODWOKEN_TESTNET,
  ChainId.CALLISTO,
  ChainId.CALLISTO_TESTNET,
  ChainId.EVMOS,
  ChainId.EVMOS_TESTNET,
  ChainId.ENERGY_WEB_CHAIN,
  ChainId.ENERGY_VOLTA,
  ChainId.BASE,
  ChainId.BASE_GOERLI,
  ChainId.KAVA,
  ChainId.KAVA_TESTNET,
  ChainId.CLOVER,
  ChainId.CLOVER_TESTNET,
  ChainId.DEFICHAIN,
  ChainId.DEFICHAIN_TESTNET,
  ChainId.BRONOS,
  ChainId.BRONOS_TESTNET,
  ChainId.FILECOIN,
  ChainId.FILECOIN_CALIBRATION,
  ChainId.FLARE,
  ChainId.FLARE_TESTNET,
  ChainId.TARAXA,
  ChainId.TARAXA_TESTNET,
  ChainId.ZKSYNC,
  ChainId.ZKSYNC_TESTNET,
  ChainId.LINEA_TESTNET
] as const

export const supportedChainIdV3 = [
  ChainId.FIRECHAIN,
  ChainId.RINIA,
  ChainId.BSC,
  ChainId.BSC_TESTNET,
  ChainId.ETHEREUM,
  ChainId.GOERLI,
  ChainId.SEPOLIA,
  ChainId.POLYGON,
  ChainId.POLYGON_MUMBAI,
  ChainId.POLYGON_ZKEVM,
  ChainId.POLYGON_ZKEVM_TESTNET,
  ChainId.CRO,
  ChainId.CRO_TESTNET,
  ChainId.AVALANCHE,
  ChainId.AVALANCHE_FUJI,
  ChainId.FANTOM_OPERA,
  ChainId.FANTOM_TESTNET,
  ChainId.CELO,
  ChainId.CELO_ALFAJORES,
  ChainId.OPTIMISM,
  ChainId.OPTIMISM_GOERLI,
  ChainId.ARBITRUM_ONE,
  ChainId.ARBITRUM_GOERLI,
  ChainId.SHIBARIUM,
  ChainId.SHIBARIUM_TESTNET,
  ChainId.PULSECHAIN,
  ChainId.PULSECHAIN_TESTNET,
  ChainId.XEN,
  ChainId.XEN_DEVNET,
  ChainId.HARMONY,
  ChainId.HARMONY_TESTNET,
  ChainId.COINEX,
  ChainId.COINEX_TESTNET,
  ChainId.DOGECHAIN,
  ChainId.DOGECHAIN_TESTNET,
  ChainId.ETHEREUM_CLASSIC,
  ChainId.ETHEREUM_CLASSIC_TESTNET,
  ChainId.FUSION,
  ChainId.FUSION_TESTNET,
  ChainId.HECO,
  ChainId.HECO_TESTNET,
  ChainId.KCC,
  ChainId.KCC_TESTNET,
  ChainId.KLAYTN,
  ChainId.KLAYTN_BAOBAB,
  ChainId.OKXCHAIN,
  ChainId.OKXCHAIN_TESTNET,
  ChainId.THETHA,
  ChainId.THETHA_TESTNET,
  ChainId.ULTRON,
  ChainId.ULTRON_TESTNET,
  ChainId.MOONBEAM,
  ChainId.MOONRIVER,
  ChainId.MOONBASE_ALPHA,
  ChainId.AURORA,
  ChainId.AURORA_TESTNET,
  ChainId.BOBA,
  ChainId.BOBA_GOERLI,
  ChainId.GNOSIS,
  ChainId.GNOSIS_CHIADO,
  ChainId.METIS,
  ChainId.METIS_GOERLI,
  ChainId.TELOS,
  ChainId.TELOS_TESTNET,
  ChainId.SYSCOIN,
  ChainId.SYSCOIN_TANENBAUM,
  ChainId.IOTEX,
  ChainId.IOTEX_TESTNET,
  ChainId.SHIDEN,
  ChainId.ASTAR,
  ChainId.SHIBUNYA,
  ChainId.FUSE,
  ChainId.FUSE_SPARKNET,
  ChainId.VELAS,
  ChainId.VELAS_TESTNET,
  ChainId.REI,
  ChainId.REI_TESTNET,
  ChainId.KEKCHAIN,
  ChainId.KEKCHAIN_TESTNET,
  ChainId.TOMOCHAIN,
  ChainId.TOMOCHAIN_TESTNET,
  ChainId.THUNDERCORE,
  ChainId.THUNDERCORE_TESTNET,
  ChainId.WANCHAIN,
  ChainId.WANCHAIN_TESTNET,
  ChainId.RSK,
  ChainId.RSK_TESTNET,
  ChainId.ELASTOS,
  ChainId.ELASTOS_TESTNET,
  ChainId.CONFLUX,
  ChainId.CONFLUX_TESTNET,
  ChainId.BRISECHAIN,
  ChainId.BRISECHAIN_TESTNET,
  ChainId.MUUCHAIN,
  ChainId.MUUCHAIN_TESTNET,
  ChainId.CANTO,
  ChainId.CANTO_TESTNET,
  ChainId.OASIS_EMERALD,
  ChainId.OASIS_TESTNET,
  ChainId.VISION,
  ChainId.VISION_TESTNET,
  ChainId.STEP,
  ChainId.STEP_TESTNET,
  ChainId.METER,
  ChainId.METER_TESTNET,
  ChainId.GODWOKEN,
  ChainId.GODWOKEN_TESTNET,
  ChainId.CALLISTO,
  ChainId.CALLISTO_TESTNET,
  ChainId.EVMOS,
  ChainId.EVMOS_TESTNET,
  ChainId.ENERGY_WEB_CHAIN,
  ChainId.ENERGY_VOLTA,
  ChainId.BASE,
  ChainId.BASE_GOERLI,
  ChainId.KAVA,
  ChainId.KAVA_TESTNET,
  ChainId.CLOVER,
  ChainId.CLOVER_TESTNET,
  ChainId.DEFICHAIN,
  ChainId.DEFICHAIN_TESTNET,
  ChainId.BRONOS,
  ChainId.BRONOS_TESTNET,
  ChainId.FILECOIN,
  ChainId.FILECOIN_CALIBRATION,
  ChainId.FLARE,
  ChainId.FLARE_TESTNET,
  ChainId.TARAXA,
  ChainId.TARAXA_TESTNET,
  ChainId.ZKSYNC,
  ChainId.ZKSYNC_TESTNET,
  ChainId.LINEA_TESTNET
] as const
export const bCakeSupportedChainId = [
  ChainId.BSC
] as const

export const FARM_AUCTION_HOSTING_IN_SECONDS = 691200

export type FarmSupportedChainId = (typeof supportedChainIdV3)[number]

export const masterChefAddresses = {
  [ChainId.BSC_TESTNET]: '0xB4A466911556e39210a6bB2FaECBB59E4eB7E43d',
  [ChainId.BSC]: '0xa5f8C5Dbd5F286960b9d90548680aE5ebFf07652',
} as const

export const masterChefV3Addresses = {
  [ChainId.FIRECHAIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.RINIA]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ETHEREUM]: '0x556B9306565093C855AEA9AE92A594704c2Cd59e',
  [ChainId.GOERLI]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.SEPOLIA]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.BSC]: '0x556B9306565093C855AEA9AE92A594704c2Cd59e',
  [ChainId.BSC_TESTNET]: '0x4c650FB471fe4e0f476fD3437C3411B1122c4e3B',

  [ChainId.POLYGON]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.POLYGON_MUMBAI]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.POLYGON_ZKEVM]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.POLYGON_ZKEVM_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.CRO]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.CRO_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.AVALANCHE]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.AVALANCHE_FUJI]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.FANTOM_OPERA]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.FANTOM_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.CELO]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.CELO_ALFAJORES]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.OPTIMISM]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.OPTIMISM_GOERLI]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ARBITRUM_ONE]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ARBITRUM_GOERLI]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.SHIBARIUM]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.SHIBARIUM_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.PULSECHAIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.PULSECHAIN_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.XEN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.XEN_DEVNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.HARMONY]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.HARMONY_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.COINEX]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.COINEX_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.DOGECHAIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.DOGECHAIN_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ETHEREUM_CLASSIC]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.FUSION]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.FUSION_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.HECO]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.HECO_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.KCC]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.KCC_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.KLAYTN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.KLAYTN_BAOBAB]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.OKXCHAIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.OKXCHAIN_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.THETHA]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.THETHA_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ULTRON]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ULTRON_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.MOONBEAM]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.MOONRIVER]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.MOONBASE_ALPHA]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.AURORA]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.AURORA_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.BOBA]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.BOBA_GOERLI]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.GNOSIS]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.GNOSIS_CHIADO]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.METIS]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.METIS_GOERLI]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.TELOS]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.TELOS_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.SYSCOIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.SYSCOIN_TANENBAUM]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.IOTEX]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.IOTEX_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.SHIDEN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ASTAR]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.SHIBUNYA]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.FUSE]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.FUSE_SPARKNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.VELAS]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.VELAS_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.REI]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.REI_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.KEKCHAIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.KEKCHAIN_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.TOMOCHAIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.TOMOCHAIN_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.THUNDERCORE]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.THUNDERCORE_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.WANCHAIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.WANCHAIN_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.RSK]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.RSK_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ELASTOS]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ELASTOS_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.CONFLUX]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.CONFLUX_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.BRISECHAIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.BRISECHAIN_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.MUUCHAIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.MUUCHAIN_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.CANTO]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.CANTO_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.OASIS_EMERALD]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.OASIS_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.VISION]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.VISION_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.STEP]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.STEP_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.METER]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.METER_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.GODWOKEN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.GODWOKEN_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.CALLISTO]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.CALLISTO_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.EVMOS]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.EVMOS_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ENERGY_WEB_CHAIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ENERGY_VOLTA]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.BASE]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.BASE_GOERLI]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.KAVA]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.KAVA_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.CLOVER]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.CLOVER_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.DEFICHAIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.DEFICHAIN_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.BRONOS]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.BRONOS_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.FILECOIN]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.FILECOIN_CALIBRATION]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.FLARE]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.FLARE_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.TARAXA]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.TARAXA_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ZKSYNC]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.ZKSYNC_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
  [ChainId.LINEA_TESTNET]: '0x864ED564875BdDD6F421e226494a0E7c071C06f8',
} as const satisfies Record<FarmSupportedChainId, string>

export const nonBSCVaultAddresses = {
  [ChainId.FIRECHAIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.RINIA]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ETHEREUM]: '0x2e71B2688019ebdFDdE5A45e6921aaebb15b25fb',
  [ChainId.GOERLI]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.SEPOLIA]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.POLYGON]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.POLYGON_MUMBAI]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.POLYGON_ZKEVM]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.POLYGON_ZKEVM_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.CRO]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.CRO_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.AVALANCHE]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.AVALANCHE_FUJI]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.FANTOM_OPERA]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.FANTOM_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.CELO]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.CELO_ALFAJORES]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.OPTIMISM]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.OPTIMISM_GOERLI]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ARBITRUM_ONE]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ARBITRUM_GOERLI]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.SHIBARIUM]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.SHIBARIUM_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.PULSECHAIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.PULSECHAIN_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.XEN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.XEN_DEVNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.HARMONY]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.HARMONY_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.COINEX]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.COINEX_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.DOGECHAIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.DOGECHAIN_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ETHEREUM_CLASSIC]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.FUSION]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.FUSION_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.HECO]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.HECO_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.KCC]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.KCC_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.KLAYTN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.KLAYTN_BAOBAB]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.OKXCHAIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.OKXCHAIN_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.THETHA]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.THETHA_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ULTRON]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ULTRON_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.MOONBEAM]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.MOONRIVER]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.MOONBASE_ALPHA]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.AURORA]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.AURORA_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.BOBA]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.BOBA_GOERLI]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.GNOSIS]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.GNOSIS_CHIADO]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.METIS]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.METIS_GOERLI]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.TELOS]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.TELOS_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.SYSCOIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.SYSCOIN_TANENBAUM]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.IOTEX]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.IOTEX_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.SHIDEN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ASTAR]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.SHIBUNYA]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.FUSE]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.FUSE_SPARKNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.VELAS]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.VELAS_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.REI]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.REI_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.KEKCHAIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.KEKCHAIN_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.TOMOCHAIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.TOMOCHAIN_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.THUNDERCORE]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.THUNDERCORE_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.WANCHAIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.WANCHAIN_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.RSK]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.RSK_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ELASTOS]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ELASTOS_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.CONFLUX]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.CONFLUX_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.BRISECHAIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.BRISECHAIN_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.MUUCHAIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.MUUCHAIN_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.CANTO]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.CANTO_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.OASIS_EMERALD]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.OASIS_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.VISION]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.VISION_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.STEP]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.STEP_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.METER]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.METER_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.GODWOKEN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.GODWOKEN_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.CALLISTO]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.CALLISTO_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.EVMOS]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.EVMOS_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ENERGY_WEB_CHAIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ENERGY_VOLTA]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.BASE]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.BASE_GOERLI]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.KAVA]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.KAVA_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.CLOVER]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.CLOVER_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.DEFICHAIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.DEFICHAIN_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.BRONOS]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.BRONOS_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.FILECOIN]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.FILECOIN_CALIBRATION]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.FLARE]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.FLARE_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.TARAXA]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.TARAXA_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ZKSYNC]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.ZKSYNC_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  [ChainId.LINEA_TESTNET]: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
} as const
